import http from '../utils/http-common';
import { StatsResponse } from '../types/common.types';
import {
  AnalyticsInput,
  CreateUserInput,
  MultiUserAnalyticsResponse,
  OrgUserListResponse,
  SingleUserAnalyticsResponse,
  UserChatDataResponse,
  UserChatListInput,
  UserChatsDataResponse,
  UserChatsList,
  UserListInput,
  UserListResponse,
} from '../types/user.types';
import { APIResponse } from '@answerr/types';

const config = {
  headers: {
    'Content-Type': 'multipart/form-data;',
    // Authorization: `Bearer qIH81df9WTWvTr5zLAwJxS7cJ4EuCpTp2UyUXwOGlSxVU11dT2b93ZdTCFtXadsA`,
  },
};

const getDashboardStats = (orgId: string) => {
  return http.post<StatsResponse>('/users/get-stats', { orgId });
};

const getEnterpriseUsers = (data: UserListInput) => {
  return http.post<UserListResponse>('/users/list', data);
};

const uploadBulkUserData = (file: File, orgId: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('orgId', orgId);

  // Don't set Content-Type header - axios auto-sets it with correct boundary for FormData
  return http.post('/users/bulk-user-update', formData);
};

const getUserChatData = (data: UserChatListInput) => {
  return http.post<UserChatDataResponse>('/users/chat-data', data);
};

const createOrgUser = (input: CreateUserInput) => {
  return http.post<APIResponse>('/users/create-user', input);
};

const deleteUser = (userId: string) => {
  return http.post<APIResponse>('/users/delete-user', { userId });
};

const updateUserStatus = (userId: string, status: 'active' | 'inactive') => {
  return http.post<APIResponse>('/users/update-user-status', { userId, status });
};

const downloadUserChatData = (data: UserChatsList) => {
  return http.post<UserChatsDataResponse>('/users/all-user-chat-data', data);
};

const getOrgUserList = () => {
  return http.post<OrgUserListResponse>('/users/users-by-id');
};

const getSingleUserAnalytics = (data: AnalyticsInput) => {
  return http.post<SingleUserAnalyticsResponse>('/analytics/single-user', data);
};

const getMultipleUserAnalytics = (data: AnalyticsInput) => {
  return http.post<MultiUserAnalyticsResponse>(
    '/analytics/multiple-user',
    data
  );
};

const updateCompanyLogo = (data: FormData) => {
  return http.post<any>('/users/image-upload', data, config);
};

const EnterpriseUserService = {
  getDashboardStats,
  getEnterpriseUsers,
  getUserChatData,
  createOrgUser,
  deleteUser,
  updateUserStatus,
  downloadUserChatData,
  getSingleUserAnalytics,
  getMultipleUserAnalytics,
  getOrgUserList,
  updateCompanyLogo,
  uploadBulkUserData
};

export default EnterpriseUserService;
